import { render, staticRenderFns } from "./ReportsHsqeNcrs.vue?vue&type=template&id=10971fdd&"
import script from "./ReportsHsqeNcrs.vue?vue&type=script&lang=js&"
export * from "./ReportsHsqeNcrs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports